import React from 'react';

const PlacementCell = () => {
  return (
    <div>
      PlacementCell
      PlacementCell
    </div>
  );
}

export default PlacementCell;
